import { List, ListItem, ListItemText, Typography } from "@mui/material";
import { Box } from "@mui/material";
import beverageIcon from "../Assets/beverages2.png";

export default function beverages() {
  const products = [
    "Fruit Juice Flavoured Instant Powder Drinks Vitamin Enriched ",
    "Fruit Juice Flavoured Instant Powder Drinks Hypertonic",
    "Fruit Juice Flavoured Concentrates",
    "Coffee Beans and Ground Coffee",
    "Bottled Water",
  ];
  return (
    <Box sx={{ textAlign: "center" }}>
      <img
        src={beverageIcon}
        alt="Beverages Icon"
        style={{ height: 70, marginBottom: 16 }}
      />
      <Typography variant="h5" fontWeight="bold" gutterBottom color="#42aec9ff">
        Range of Beverages
      </Typography>
      {/* <Typography variant="subtitle1" gutterBottom fontWeight="bold">
        Our pack sizes typically range from 500g to 25Kg or 500ml to 25L
        variants. We can also produce customised pack sizes and a variety of
        flavour variants based on volume requirements..
      </Typography> */}
      <List
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          ml: 5,
          mt: 4,
        }}
      >
        {products.map((product, idx) => (
          <ListItem
            key={idx}
            disablePadding
            sx={{ width: "auto", justifyContent: "center" }}
          >
            <ListItemText primary={`• ${product}`} sx={{ textAlign: "left" }} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
